const DEFAULT_PAGEABLE_VALUES = {
  size: 20,
  page: 0
};
export {
  DEFAULT_PAGEABLE_VALUES
};
